module.exports = __webpack_public_path__ + "img/r3c1.bb943f74.jpg";